import React, { Fragment } from 'react';

const LoadingsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Loading spinners express an unspecified wait time of a process.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Loading spinners are used when there is the need to notify the user that the system is taking some time to load in formation and that this action will require a little more time than the usual navigation on the platform.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Spinner Animation</h2>
          <p>The waiting experience is a crucial design opportunity. Although it may not be obvious what is occurring on the back-end, we can communicate clearly to reassure the user that progress is happening through design and motion.</p>
          <p>It is best practice to use a loading spinner whenever the task the user wants to complete is not immediate.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default LoadingsUsage;


// WEBPACK FOOTER //
// ./src/containers/elements/Loadings/LoadingsUsage.js